import { render, staticRenderFns } from "./popup-share.vue?vue&type=template&id=2456fea5&scoped=true&"
import script from "./popup-share.vue?vue&type=script&lang=js&"
export * from "./popup-share.vue?vue&type=script&lang=js&"
import style0 from "./popup-share.vue?vue&type=style&index=0&id=2456fea5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2456fea5",
  null
  
)

export default component.exports